
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.71 13.188H7.28L0 17.026v2.204l19.995 13.38 19.994-13.38v-2.204l-7.279-3.838z","fill":"#1BB58B"}}),_c('path',{attrs:{"d":"M39.99 17.026l-7.28-3.838H19.996v19.42L39.989 19.23v-2.204z","fill":"#1BB58B"}}),_c('path',{attrs:{"d":"M6.397 0v22.64l13.598 9.098 13.597-9.098V0H6.397z","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M33.592 0H19.996v31.738l13.596-9.098V0z","fill":"#1BB58B"}}),_c('path',{attrs:{"d":"M27.536 11.588l-5.206-.763-2.334-4.716-2.334 4.716-5.207.763 3.764 3.677-.884 5.187 4.66-2.443 4.66 2.443-.883-5.187 3.764-3.677z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M26.823 25.471l-6.828 4.318-6.829-4.317L0 36.725V40h39.99v-3.275L26.822 25.471z","fill":"#1BB58B"}}),_c('path',{attrs:{"d":"M39.99 36.725L26.822 25.471l-6.827 4.317V40h19.993v-3.275z","fill":"#1BB58B"}}),_c('path',{attrs:{"d":"M0 17.026V40l15.367-13.137L0 17.026z","fill":"#1B342C"}}),_c('path',{attrs:{"d":"M24.62 26.864L39.99 40V17.026l-15.37 9.838z","fill":"#FFD567"}}),_c('path',{attrs:{"d":"M24.62 26.864L39.99 40V17.026l-15.37 9.838z","fill":"#1B342C"}}),_c('path',{attrs:{"d":"M27.536 11.588l-5.206-.763-2.334-4.716v11.9l4.66 2.443-.884-5.187 3.764-3.677z","fill":"#FFF"}})])
          )
        }
      }
    